module.exports = __webpack_public_path__ + "img/pursuits_gray.114cddbd.png";